import React from "react";
import { hideUploadProgress } from "@/store/app/app.slice";
import { DRIVE_TAB } from "./tabConstants";
import {
  Tv,
  Music,
  Video,
  BarChart3,
  Settings,
  FileVideo,
  Upload,
  Link,
  Archive,
  Layers,
  Megaphone,
  Film,
  Volume2,
  Files,
  Scissors,
  Zap,
} from "lucide-react";

export const MEDIA_LIST_MORE_ACTIONS = [
  "embed",
  "archive",
  "delete",
  "simulive",
  "clone",
  "duplicate",
  "convert to podcast",
  "podcast",
];

export type MediaDetailsMoreAction = {
  key: string;
  icon: string;
};

export const MEDIA_DETAILS_MORE_ACTIONS: MediaDetailsMoreAction[] = [
  { key: "Archive", icon: "bi bi-archive" },
  { key: "Delete", icon: "bi bi-trash3" },
];

export const PRODUCTION_TYPE = [
  {
    label: "In House Originals",
    value: "In House Originals",
  },
  {
    label: "Wired",
    value: "Wired",
  },
  {
    label: "AI Generated",
    value: "AI Generated",
  },
  {
    label: "AI Assisted",
    value: "AI Assisted",
  },
];

export const CONTENT_TYPE = [
  {
    label: "Interview",
    value: "interview",
  },
  {
    label: "Explainers",
    value: "explainers",
  },
  {
    label: "Package",
    value: "package",
  },
  {
    label: "Story",
    value: "story",
  },
  {
    label: "Bytes",
    value: "bytes",
  },
  {
    label: "VoxPop",
    value: "voxPop",
  },
  {
    label: "Live",
    value: "live",
  },
  {
    label: "Podcast",
    value: "podcast",
  },
  {
    label: "Music",
    value: "music",
  },
  {
    label: "Advertorial",
    value: "advertorial",
  },
  {
    label: "Campaign",
    value: "campaign",
  },
  {
    label: "Premiere",
    value: "premiere",
  },
];
export const fileProcessingStatusToText = {
  1: "Created",
  2: "Uploading",
  3: "Uploaded ",
  // 4: 'Verified ',
  // 6: 'Processing ',
  7: "Processing ",
  8: "Verifying",
  9: "Ready",
  10: "Archived",
  11: "Deleted",
  12: "Error",
};

export const ALLOWED_FILE_EXTENSION: Record<string, string[]> = {
  ALL: [
    "flv",
    "mp4",
    "avi",
    "mkv",
    "ogg",
    "m4p",
    "mpeg",
    "3gp",
    "m4v",
    "mov",
    "wmv",
    "mp3",
    "jpeg",
    "jpg",
    "png",
    "gif",
    "wav",
    "aac",
  ],
  AUDIO: ["mp3", "wav", "aac"],
  VIDEO: [
    "flv",
    "mp4",
    "avi",
    "mkv",
    "ogg",
    "m4p",
    "mpeg",
    "3gp",
    "m4v",
    "mov",
    "wmv",
  ],
  GIF: ["gif"],
  IMAGE: ["jpeg", "jpg", "png"],
  SUBTITLE: ["srt", "vtt", "txt"],
};

// Media status mapper
export const MEDIA_STATUS = {
  MEDIA_STATUS_DRAFT: 0,
  MEDIA_STATUS_PUBLISHING: 1,
  MEDIA_STATUS_PUBLISHED: 2,
  MEDIA_STATUS_INACTIVE: 3,
  MEDIA_STATUS_DELETED: -2,
  MEDIA_STATUS_ERROR: -3,
};

export const SOCIAL_PUBLISH_STATUS = {
  QUEUE: 0,
  IN_PROGRESS: 1,
  COMPLETED: 10,
  DRAFT: 12,
  FAILED: -1,
};

// What portion of the source video a social destination was published from.
export const PUBLISH_RANGE_TYPE = {
  FULL: "full",
  CLIPS: "clips",
  SEGMENT: "segment",
} as const;

export type PublishRangeType =
  (typeof PUBLISH_RANGE_TYPE)[keyof typeof PUBLISH_RANGE_TYPE];

export const DEFAULT_YOUTUBE_CATEGORIES = {
  "Autos & Vehicles": "Autos & Vehicles",
  Comedy: "Comedy",
  Education: "Education",
  Entertainment: "Entertainment",
  "Film & Animation": "Film & Animation",
  Gaming: "Gaming",
  "Howto & Style": "Howto & Style",
  Music: "Music",
  "News & Politics": "News & Politics",
  "Nonprofits & Activism": "Nonprofits & Activism",
  "People & Blogs": "People & Blogs",
  "Pets & Animals": "Pets & Animals",
  "Science & Technology": "Science & Technology",
  Sports: "Sports",
  "Travel & Events": "Travel & Events",
};

export const VIDEOFLAVOR = [
  { value: "10", label: "1080p_3300" },
  { value: "20", label: "720p_1600" },
  { value: "30", label: "480p_900" },
  { value: "40", label: "360p_600" },
  { value: "51", label: "240p_256" },
  { value: "60", label: "144p_100" },
];
export const AUDIOFLAVOR = [
  { value: "91", label: "A_MP4_128" },
  { value: "93", label: "A_MP4_64" },
  { value: "95", label: "A_MP3_256" },
  { value: "103", label: "A_MP3_128" },
];

export const COUNTRIES = [
  { value: "ad", label: "Andorra" },
  { value: "ae", label: "United Arab Emirates" },
  { value: "af", label: "Afghanistan" },
  { value: "ag", label: "Antigua and Barbuda" },
  { value: "ai", label: "Anguilla" },
  { value: "al", label: "Albania" },
  { value: "am", label: "Armenia" },
  { value: "ao", label: "Angola" },
  { value: "aq", label: "Antarctica" },
  { value: "ar", label: "Argentina" },
  { value: "as", label: "American Samoa" },
  { value: "at", label: "Austria" },
  { value: "au", label: "Australia" },
  { value: "aw", label: "Aruba" },
  { value: "ax", label: "Aland Islands" },
  { value: "az", label: "Azerbaijan" },
  { value: "ba", label: "Bosnia and Herzegovina" },
  { value: "bb", label: "Barbados" },
  { value: "bd", label: "Bangladesh" },
  { value: "be", label: "Belgium" },
  { value: "bf", label: "Burkina Faso" },
  { value: "bg", label: "Bulgaria" },
  { value: "bh", label: "Bahrain" },
  { value: "bi", label: "Burundi" },
  { value: "bj", label: "Benin" },
  { value: "bl", label: "Saint Barthelemy" },
  { value: "bm", label: "Bermuda" },
  { value: "bn", label: "Brunei Darussalam" },
  { value: "bo", label: "Bolivia Plurinational State of" },
  { value: "bq", label: "Bonaire Sint Eustatius and Saba" },
  { value: "br", label: "Brazil" },
  { value: "bs", label: "Bahamas" },
  { value: "bt", label: "Bhutan" },
  { value: "bv", label: "Bouvet Island" },
  { value: "bw", label: "Botswana" },
  { value: "by", label: "Belarus" },
  { value: "bz", label: "Belize" },
  { value: "ca", label: "Canada" },
  { value: "cc", label: "Cocos (Keeling) Islands" },
  { value: "cd", label: "Congo The Democratic Republic of the" },
  { value: "cf", label: "Central African Republic" },
  { value: "cg", label: "Congo" },
  { value: "ch", label: "Switzerland" },
  { value: "ci", label: "Cote d'Ivoire" },
  { value: "ck", label: "Cook Islands" },
  { value: "cl", label: "Chile" },
  { value: "cm", label: "Cameroon" },
  { value: "cn", label: "China" },
  { value: "co", label: "Colombia" },
  { value: "cr", label: "Costa Rica" },
  { value: "cu", label: "Cuba" },
  { value: "cv", label: "Cape Verde" },
  { value: "cw", label: "Curacao" },
  { value: "cx", label: "Christmas Island" },
  { value: "cy", label: "Cyprus" },
  { value: "cz", label: "Czech Republic" },
  { value: "de", label: "Germany" },
  { value: "dj", label: "Djibouti" },
  { value: "dk", label: "Denmark" },
  { value: "dm", label: "Dominica" },
  { value: "do", label: "Dominican Republic" },
  { value: "dz", label: "Algeria" },
  { value: "ec", label: "Ecuador" },
  { value: "ee", label: "Estonia" },
  { value: "eg", label: "Egypt" },
  { value: "eh", label: "Western Sahara" },
  { value: "er", label: "Eritrea" },
  { value: "es", label: "Spain" },
  { value: "et", label: "Ethiopia" },
  { value: "fi", label: "Finland" },
  { value: "fj", label: "Fiji" },
  { value: "fk", label: "Falkland Islands (Malvinas)" },
  { value: "fm", label: "Micronesia Federated States of" },
  { value: "fo", label: "Faroe Islands" },
  { value: "fr", label: "France" },
  { value: "ga", label: "Gabon" },
  { value: "gb", label: "United Kingdom" },
  { value: "gd", label: "Grenada" },
  { value: "ge", label: "Georgia" },
  { value: "gf", label: "French Guiana" },
  { value: "gg", label: "Guernsey" },
  { value: "gh", label: "Ghana" },
  { value: "gi", label: "Gibraltar" },
  { value: "gl", label: "Greenland" },
  { value: "gm", label: "Gambia" },
  { value: "gn", label: "Guinea" },
  { value: "gp", label: "Guadeloupe" },
  { value: "gq", label: "Equatorial Guinea" },
  { value: "gr", label: "Greece" },
  { value: "gs", label: "South Georgia and the South Sandwich Islands" },
  { value: "gt", label: "Guatemala" },
  { value: "gu", label: "Guam" },
  { value: "gw", label: "Guinea-Bissau" },
  { value: "gy", label: "Guyana" },
  { value: "hk", label: "Hong Kong" },
  { value: "hm", label: "Heard Island and McDonald Islands" },
  { value: "hn", label: "Honduras" },
  { value: "hr", label: "Croatia" },
  { value: "ht", label: "Haiti" },
  { value: "hu", label: "Hungary" },
  { value: "id", label: "Indonesia" },
  { value: "ie", label: "Ireland" },
  { value: "il", label: "Israel" },
  { value: "im", label: "Isle of Man" },
  { value: "in", label: "India" },
  { value: "io", label: "British Indian Ocean Territory" },
  { value: "iq", label: "Iraq" },
  { value: "ir", label: "Iran Islamic Republic of" },
  { value: "is", label: "Iceland" },
  { value: "it", label: "Italy" },
  { value: "je", label: "Jersey" },
  { value: "jm", label: "Jamaica" },
  { value: "jo", label: "Jordan" },
  { value: "jp", label: "Japan" },
  { value: "ke", label: "Kenya" },
  { value: "kg", label: "Kyrgyzstan" },
  { value: "kh", label: "Cambodia" },
  { value: "ki", label: "Kiribati" },
  { value: "km", label: "Comoros" },
  { value: "kn", label: "Saint Kitts and Nevis" },
  { value: "kp", label: "Korea Democratic People's Republic of" },
  { value: "kr", label: "Korea Republic of" },
  { value: "kw", label: "Kuwait" },
  { value: "ky", label: "Cayman Islands" },
  { value: "kz", label: "Kazakhstan" },
  { value: "la", label: "Lao People's Democratic Republic" },
  { value: "lb", label: "Lebanon" },
  { value: "lc", label: "Saint Lucia" },
  { value: "li", label: "Liechtenstein" },
  { value: "lk", label: "Sri Lanka" },
  { value: "lr", label: "Liberia" },
  { value: "ls", label: "Lesotho" },
  { value: "lt", label: "Lithuania" },
  { value: "lu", label: "Luxembourg" },
  { value: "lv", label: "Latvia" },
  { value: "ly", label: "Libya" },
  { value: "ma", label: "Morocco" },
  { value: "mc", label: "Monaco" },
  { value: "md", label: "Moldova Republic of" },
  { value: "me", label: "Montenegro" },
  { value: "mf", label: "Saint Martin (French part)" },
  { value: "mg", label: "Madagascar" },
  { value: "mh", label: "Marshall Islands" },
  { value: "mk", label: "Macedonia The Former Yugoslav Republic of" },
  { value: "ml", label: "Mali" },
  { value: "mm", label: "Myanmar" },
  { value: "mn", label: "Mongolia" },
  { value: "mo", label: "Macao" },
  { value: "mp", label: "Northern Mariana Islands" },
  { value: "mq", label: "Martinique" },
  { value: "mr", label: "Mauritania" },
  { value: "ms", label: "Montserrat" },
  { value: "mt", label: "Malta" },
  { value: "mu", label: "Mauritius" },
  { value: "mv", label: "Maldives" },
  { value: "mw", label: "Malawi" },
  { value: "mx", label: "Mexico" },
  { value: "my", label: "Malaysia" },
  { value: "mz", label: "Mozambique" },
  { value: "na", label: "Namibia" },
  { value: "nc", label: "New Caledonia" },
  { value: "ne", label: "Niger" },
  { value: "nf", label: "Norfolk Island" },
  { value: "ng", label: "Nigeria" },
  { value: "ni", label: "Nicaragua" },
  { value: "nl", label: "Netherlands" },
  { value: "no", label: "Norway" },
  { value: "np", label: "Nepal" },
  { value: "nr", label: "Nauru" },
  { value: "nu", label: "Niue" },
  { value: "nz", label: "New Zealand" },
  { value: "om", label: "Oman" },
  { value: "pa", label: "Panama" },
  { value: "pe", label: "Peru" },
  { value: "pf", label: "French Polynesia" },
  { value: "pg", label: "Papua New Guinea" },
  { value: "ph", label: "Philippines" },
  { value: "pk", label: "Pakistan" },
  { value: "pl", label: "Poland" },
  { value: "pm", label: "Saint Pierre and Miquelon" },
  { value: "pn", label: "Pitcairn" },
  { value: "pr", label: "Puerto Rico" },
  { value: "ps", label: "Palestinian Territory Occupied" },
  { value: "pt", label: "Portugal" },
  { value: "pw", label: "Palau" },
  { value: "py", label: "Paraguay" },
  { value: "qa", label: "Qatar" },
  { value: "re", label: "Reunion" },
  { value: "ro", label: "Romania" },
  { value: "rs", label: "Serbia" },
  { value: "ru", label: "Russian Federation" },
  { value: "rw", label: "Rwanda" },
  { value: "sa", label: "Saudi Arabia" },
  { value: "sb", label: "Solomon Islands" },
  { value: "sc", label: "Seychelles" },
  { value: "sd", label: "Sudan" },
  { value: "se", label: "Sweden" },
  { value: "sg", label: "Singapore" },
  { value: "sh", label: "Saint Helena" },
  { value: "si", label: "Slovenia" },
  { value: "sj", label: "Svalbard and Jan Mayen" },
  { value: "sk", label: "Slovakia" },
  { value: "sl", label: "Sierra Leone" },
  { value: "sm", label: "San Marino" },
  { value: "sn", label: "Senegal" },
  { value: "so", label: "Somalia" },
  { value: "sr", label: "Suriname" },
  { value: "ss", label: "South Sudan" },
  { value: "st", label: "Sao Tome and Principe" },
  { value: "sv", label: "El Salvador" },
  { value: "sx", label: "Sint Maarten (Dutch part)" },
  { value: "sy", label: "Syrian Arab Republic" },
  { value: "sz", label: "Swaziland" },
  { value: "tc", label: "Turks and Caicos Islands" },
  { value: "td", label: "Chad" },
  { value: "tf", label: "French Southern Territories" },
  { value: "tg", label: "Togo" },
  { value: "th", label: "Thailand" },
  { value: "tj", label: "Tajikistan" },
  { value: "tk", label: "Tokelau" },
  { value: "tl", label: "Timor-Leste" },
  { value: "tm", label: "Turkmenistan" },
  { value: "tn", label: "Tunisia" },
  { value: "to", label: "Tonga" },
  { value: "tr", label: "Turkey" },
  { value: "tt", label: "Trinidad and Tobago" },
  { value: "tv", label: "Tuvalu" },
  { value: "tw", label: "Taiwan Province of China" },
  { value: "tz", label: "Tanzania, United Republic of" },
  { value: "ua", label: "Ukraine" },
  { value: "ug", label: "Uganda" },
  { value: "um", label: "United States Minor Outlying Islands" },
  { value: "us", label: "United States" },
  { value: "uy", label: "Uruguay" },
  { value: "uz", label: "Uzbekistan" },
  { value: "va", label: "Holy See (Vatican City State)" },
  { value: "vc", label: "Saint Vincent and the Grenadines" },
  { value: "ve", label: "Venezuela, Bolivarian Republic of" },
  { value: "vg", label: "Virgin Islands (British)" },
  { value: "vi", label: "Virgin Islands (U.S.)" },
  { value: "vn", label: "Viet Nam" },
  { value: "vu", label: "Vanuatu" },
  { value: "wf", label: "Wallis and Futuna" },
  { value: "ws", label: "Samoa" },
  { value: "ye", label: "Yemen" },
  { value: "yt", label: "Mayotte" },
  { value: "za", label: "South Africa" },
  { value: "zm", label: "Zambia" },
  { value: "zw", label: "Zimbabwe" },
];

export const SERVICES = [
  { value: "analytics", label: "Analytics" },
  { value: "cms", label: "CMS" },
  { value: "live", label: "Live" },
  { value: "chopper", label: "Chopper" },
  {
    value: "optimus",
    label: "Optimus",
  },
  { value: "All", label: "All" },
];

export const FLAVOR_LIST = [
  { value: "10", label: "mp4" },
  { value: "20", label: "mp4" },
  { value: "25", label: "mp4" },
  { value: "30", label: "mp4" },
  { value: "40", label: "mp4" },
  { value: "51", label: "mp4" },
  { value: "60", label: "mp4" },
  { value: "80", label: "preview" },
  { value: "91", label: "mp4" },
  { value: "93", label: "mp4" },
  { value: "95", label: "mp4" },
  { value: "103", label: "mp3" },
  { value: "104", label: "mp4" },
  { value: "105", label: "mp3" },
  { value: "109", label: "mp3" },
];

export const DISCOVER_NAV_TABS = [
  { label: "Wired", key: "wired", icon: Video },
  { label: "Inhouse", key: "inhouse", icon: Music },
];
export const DISCOVER_TAB_MAPPING = {
  wired: "wired",
  inhouse: "inhouse",
};

export const APP_LAUNCHER_CONFIG = [
  {
    id: "live-studio",
    label: "Live Studio",
    icon: Tv,
    path: "https://cms.sli.ke/",
    description: "Professional live streaming",
  },
  {
    id: "fast-uploader",
    label: "Fast Uploader",
    icon: Zap,
    path: "https://ftp.sli.ke/",
    description: "Fast file uploader",
  },
  {
    id: "chopper",
    label: "Chopper",
    icon: Scissors,
    path: "https://chopper.sli.ke/",
    description: "Video chopping tool",
  },
  {
    id: "denmark",
    label: "ONSITE PL",
    icon: FileVideo,
    path: "https://denmark.timesinternet.in/",
    description: "Onsite Priority List",
  },
  {
    id: "analytics",
    label: "Analytics",
    icon: BarChart3,
    path: "https://data.slike.in/dashboard",
    description: "Performance insights",
  },
  {
    id: "settings",
    label: "Settings",
    icon: Settings,
    path: "/setting",
    description: "Performance insights",
  },
];

export const CREATE_OPTIONS = [
  {
    type: "uploader",
    id: "video",
    datatype: "VIDEO",
    title: "Video",
    description: "Full videos",
    Icon: Video,
    asset_type: "video",
  },

  {
    type: "uploader",
    id: "shorts",
    datatype: "VIDEO",
    title: "Shorts",
    description: "Shorts/Reels videos",
    Icon: Film,
    asset_type: "shorts",
  },
  {
    type: "action",
    id: "CUSTOM_UPLOADS",
    title: "Custom Upload",
    description: "FTP, YT, URL, GDrive",
    Icon: Upload,
    asset_type: "custom",
  },
  {
    type: "action",
    id: "EMBED",
    title: "Embed",
    description: "YT, FB, Stream URLs",
    Icon: Link,
    asset_type: "embed",
  },
  {
    type: "uploader",
    id: "audio",
    datatype: "AUDIO",
    title: "Audio",
    description: "Music & Podcasts",
    Icon: Music,
    asset_type: "audio",
  },
  {
    type: "uploader",
    id: DRIVE_TAB,
    datatype: "VIDEO",
    title: "Drive",
    description: "Asset repository",
    Icon: Archive,
    asset_type: DRIVE_TAB,
  },
  {
    type: "uploader",
    id: "slates",
    datatype: "VIDEO",
    title: "Slate",
    description: "Pre/post slates",
    Icon: Layers,
    asset_type: "slates",
  },
  {
    type: "uploader",
    id: "campaign",
    datatype: "VIDEO",
    title: "Campaign",
    description: "Promotional/Ad videos",
    Icon: Megaphone,
    asset_type: "campaign",
  },
  {
    type: "action",
    id: "TEXT_TO_SPEECH",
    title: "Text to Speech",
    description: "Convert text to audio",
    Icon: Volume2,
    asset_type: "audio",
  },
  {
    type: "action",
    id: "PREMIERE",
    title: "Premiere",
    description: "Schedule & premiere",
    Icon: Tv,
    asset_type: "premiere",
  },
  {
    type: "action",
    id: "BULK_UPLOAD",
    title: "Multi Upload",
    description: "Upload multiple files",
    Icon: Files,
    asset_type: "video",
  },
];

export const CREATE_FALLBACK_IDS = ["video", "audio"];

export const STATUS_LIST = {
  ACTIVE: "1",
  INACTIVE: "2",
};

export const POLICY_OPTIONS = {
  HIDE: 1,
  VISIBLE: 2,
  VISIBLE_AND_MANDATORY: 3,
};

export const ADMIN_URL = {
  META_PRESETS: "/presets/metadata",
  PUBLISHING_PRESETS: "/presets/publishing",
};

export const PRESET_MODES = {
  FILL_IF_EMPTY: "fill_if_empty",
  OVERRIDE: "override",
  APPEND: "append",
  SKIP: "skip",
};

export const DENMARK_ROTATING_STATUS = [1, 2, 3, 4, 7];

export const CLEO_PLAYER_API_KEY = "slike373web5aspol9zlg";

export const HOSTS = [
  { id: "43", name: "Test" },
  { id: "53", name: "NBT- Online" },
  { id: "83", name: "TOI" },
  { id: "19", name: "ET" },
  { id: "153", name: "ET-hfi" },
  { id: "155", name: "MT- Online" },
  { id: "183", name: "Times Now" },
  { id: "245", name: "Indiatimes Vijay Karnataka" },
  { id: "248", name: "ZoomTV" },
  { id: "252", name: "eisamay" },
  { id: "261", name: "ETEnergy" },
  { id: "263", name: "ETRetail" },
  { id: "265", name: "ETAuto" },
  { id: "266", name: "ETHealth" },
  { id: "268", name: "ETTelecom" },
  { id: "269", name: "ETBFSI" },
  { id: "271", name: "ETCIO" },
  { id: "281", name: "ETBrandEquity" },
  { id: "282", name: "ETReal Estate" },
  { id: "285", name: "Tamil" },
  { id: "286", name: "Telugu" },
  { id: "287", name: "Malayalam" },
  { id: "301", name: "ETCFO" },
  { id: "314", name: "ETCISO" },
  { id: "329", name: "ETGovernment" },
  { id: "338", name: "iamgujarat" },
  { id: "341", name: "ETHospitalityWorld" },
  { id: "342", name: "ETHRWorld" },
  { id: "346", name: "ETTravelWorld" },
  { id: "352", name: "Gadget Central" },
  { id: "353", name: "TimesNow - Navbharat" },
  { id: "355", name: "Times Foodie" },
  { id: "357", name: "ET Infra" },
  { id: "359", name: "ETCISOSEA" },
  { id: "360", name: "ETHRME" },
  { id: "361", name: "ETHRSEA" },
  { id: "363", name: "RadioMirchi" },
  { id: "367", name: "ETTAMIL" },
  { id: "369", name: "ET Malayalam" },
  { id: "371", name: "Zoom Hindi" },
  { id: "372", name: "Bengali TimesXP" },
  { id: "373", name: "Gujarati TimesXP" },
  { id: "374", name: "Hindi TimesXP" },
  { id: "375", name: "Kannada TimesXP" },
  { id: "376", name: "Marathi TimesXP" },
  { id: "377", name: "Malayalam TimesXP" },
  { id: "378", name: "Tamil TimesXP" },
  { id: "379", name: "Telugu TimesXP" },
  { id: "382", name: "ET Now" },
  { id: "383", name: "TimesXP-English" },
  { id: "677", name: "ET Gujrati" },
  { id: "3812890", name: "Willo Parent" },
  { id: "388", name: "SPEAKTINGTREEHINDI" },
  { id: "292", name: "newspoint" },
  { id: "307", name: "Gadgets now" },
];

export const statusOptions = [
  {
    label: "ACTIVE",
    value: "ACTIVE",
    icon: "bi-check-circle",
    color: "#28a745",
  },
  {
    label: "CLOSED",
    value: "CLOSED",
    icon: "bi-x-circle",
    color: "#000000",
  },
  {
    label: "INACTIVE",
    value: "INACTIVE",
    icon: "bi-dash-circle",
    color: "#dc3545",
  },
  {
    label: "PENDING",
    value: "PENDING_FOR_APPROVAL",
    icon: "bi-question-circle",
    color: "#fd7e14",
  },
  {
    label: "IGNORE",
    value: "IGNORE",
    icon: "bi-slash-circle",
    color: "#0d6efd",
  },
];

export const DENMARK_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  PENDING: "PENDING",
  IGNORE: "IGNORE",
  CLOSED: "CLOSED",
  PENDING_FOR_APPROVAL: "PENDING_FOR_APPROVAL",
};

export const ElevenLabsLogo = ({ size = 32 }: { size?: number }) =>
  React.createElement(
    "svg",
    {
      width: size,
      height: size,
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
    },
    React.createElement("rect", {
      width: "32",
      height: "32",
      rx: "6",
      fill: "#000000",
    }),
    React.createElement("rect", {
      x: "10",
      y: "6",
      width: "4",
      height: "20",
      rx: "1.5",
      fill: "#ffffff",
    }),
    React.createElement("rect", {
      x: "18",
      y: "6",
      width: "4",
      height: "20",
      rx: "1.5",
      fill: "#ffffff",
    })
  );

export const AmazonPollyLogo = ({ size = 32 }: { size?: number }) =>
  React.createElement(
    "svg",
    {
      width: size,
      height: size,
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
    },
    React.createElement("rect", {
      width: "32",
      height: "32",
      rx: "6",
      fill: "#232F3E",
    }),
    React.createElement("path", {
      d: "M9 20C9 20 12 22 16 22C20 22 23 20 23 20",
      stroke: "#FF9900",
      strokeWidth: "1.8",
      strokeLinecap: "round",
    }),
    React.createElement("path", {
      d: "M21 20L23 20L22 22",
      stroke: "#FF9900",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }),
    React.createElement("path", {
      d: "M11 17V12C11 9.2 13.2 7 16 7C18.8 7 21 9.2 21 12V17",
      stroke: "#ffffff",
      strokeWidth: "1.8",
      strokeLinecap: "round",
    }),
    React.createElement("circle", {
      cx: "13.5",
      cy: "14",
      r: "1",
      fill: "#FF9900",
    }),
    React.createElement("circle", {
      cx: "18.5",
      cy: "14",
      r: "1",
      fill: "#FF9900",
    })
  );

export const GoogleTTSLogo = ({ size = 32 }: { size?: number }) =>
  React.createElement(
    "svg",
    {
      width: size,
      height: size,
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
    },
    React.createElement("rect", {
      width: "32",
      height: "32",
      rx: "6",
      fill: "#ffffff",
    }),
    React.createElement("rect", {
      x: "0.5",
      y: "0.5",
      width: "31",
      height: "31",
      rx: "5.5",
      stroke: "#ddd",
    }),
    React.createElement("circle", {
      cx: "16",
      cy: "12",
      r: "5",
      fill: "#4285F4",
    }),
    React.createElement("path", {
      d: "M16 12L20 8",
      stroke: "#EA4335",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    React.createElement("path", {
      d: "M16 12L12 8",
      stroke: "#FBBC05",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    React.createElement("path", {
      d: "M16 12L16 17",
      stroke: "#34A853",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    }),
    React.createElement("path", {
      d: "M10 22C10 22 12 20 16 20C20 20 22 22 22 22",
      stroke: "#4285F4",
      strokeWidth: "1.5",
      strokeLinecap: "round",
    })
  );

// ─── Text-to-Speech Constants ──────────────────────────────────────────────────

export const MULTI_SPEAKER_MODEL_IDS: string[] = ["eleven_v3"];

export const LANG_TO_COUNTRY: Record<string, string> = {
  en: "GB",
  af: "ZA",
  ar: "SA",
  bg: "BG",
  bs: "BA",
  ca: "ES",
  cs: "CZ",
  da: "DK",
  de: "DE",
  el: "GR",
  es: "ES",
  et: "EE",
  fi: "FI",
  fr: "FR",
  gl: "ES",
  gu: "IN",
  hi: "IN",
  hr: "HR",
  hu: "HU",
  id: "ID",
  it: "IT",
  ja: "JP",
  kn: "IN",
  ko: "KR",
  lt: "LT",
  lv: "LV",
  mk: "MK",
  ml: "IN",
  mr: "IN",
  ms: "MY",
  mt: "MT",
  nl: "NL",
  no: "NO",
  pl: "PL",
  pt: "PT",
  ro: "RO",
  ru: "RU",
  sk: "SK",
  sl: "SI",
  sq: "AL",
  sr: "RS",
  sv: "SE",
  sw: "KE",
  ta: "IN",
  te: "IN",
  th: "TH",
  tr: "TR",
  uk: "UA",
  ur: "PK",
  vi: "VN",
  zh: "CN",
  "zh-CN": "CN",
  "zh-TW": "TW",
  "pt-BR": "BR",
  "pt-PT": "PT",
  "en-US": "US",
  "en-GB": "GB",
  "en-AU": "AU",
};

export function langFlag(code: string): string {
  const country = LANG_TO_COUNTRY[code] ?? LANG_TO_COUNTRY[code.split("-")[0]];
  if (!country) return "🌐";
  return [...country.toUpperCase()]
    .map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
    .join("");
}

export interface TTSVoice {
  id: string;
  name: string;
  description: string;
  gender: "Male" | "Female";
  language: string;
  accent: string;
  category: string;
  age: string;
  color: string;
  previewUrl?: string;
}

export interface TTSService {
  id: string;
  name: string;
  description: string;
  Logo: React.FC<{ size?: number }>;
  tagline: string;
  voices: TTSVoice[];
}

export const TTS_SERVICES: TTSService[] = [
  {
    id: "elevenlabs",
    name: "ElevenLabs",
    description:
      "Ultra-realistic AI voices with emotional range and natural intonation",
    Logo: ElevenLabsLogo,
    tagline: "Most natural sounding",
    voices: [
      {
        id: "el-1",
        name: "Aria",
        description: "Expressive and confident",
        gender: "Female",
        language: "English",
        accent: "American",
        category: "Conversational",
        age: "Young Adult",
        color: "#7C3AED",
      },
      {
        id: "el-2",
        name: "Roger",
        description: "Warm and authoritative",
        gender: "Male",
        language: "English",
        accent: "British",
        category: "Narration",
        age: "Middle Aged",
        color: "#2563EB",
      },
      {
        id: "el-3",
        name: "Sarah",
        description: "Soft and professional",
        gender: "Female",
        language: "English",
        accent: "American",
        category: "Narration",
        age: "Young Adult",
        color: "#DB2777",
      },
      {
        id: "el-4",
        name: "Charlie",
        description: "Energetic and youthful",
        gender: "Male",
        language: "English",
        accent: "Australian",
        category: "Conversational",
        age: "Young Adult",
        color: "#059669",
      },
      {
        id: "el-5",
        name: "Amelia",
        description: "Calm and articulate",
        gender: "Female",
        language: "English",
        accent: "British",
        category: "News",
        age: "Middle Aged",
        color: "#D97706",
      },
      {
        id: "el-6",
        name: "Daniel",
        description: "Deep and resonant",
        gender: "Male",
        language: "English",
        accent: "American",
        category: "Narration",
        age: "Middle Aged",
        color: "#4F46E5",
      },
      {
        id: "el-7",
        name: "Luna",
        description: "Gentle and soothing",
        gender: "Female",
        language: "English",
        accent: "Irish",
        category: "ASMR",
        age: "Young Adult",
        color: "#EC4899",
      },
      {
        id: "el-8",
        name: "Marcus",
        description: "Bold and engaging",
        gender: "Male",
        language: "English",
        accent: "British",
        category: "Characters",
        age: "Middle Aged",
        color: "#0891B2",
      },
    ],
  },
  {
    id: "amazon-polly",
    name: "Amazon Polly",
    description: "Enterprise-grade text-to-speech with wide language support",
    Logo: AmazonPollyLogo,
    tagline: "Enterprise ready",
    voices: [
      {
        id: "ap-1",
        name: "Joanna",
        description: "Clear and professional",
        gender: "Female",
        language: "English",
        accent: "American",
        category: "Conversational",
        age: "Young Adult",
        color: "#FF9900",
      },
      {
        id: "ap-2",
        name: "Matthew",
        description: "Natural male voice",
        gender: "Male",
        language: "English",
        accent: "American",
        category: "Narration",
        age: "Middle Aged",
        color: "#146EB4",
      },
      {
        id: "ap-3",
        name: "Amy",
        description: "British female voice",
        gender: "Female",
        language: "English",
        accent: "British",
        category: "News",
        age: "Young Adult",
        color: "#E8365D",
      },
      {
        id: "ap-4",
        name: "Brian",
        description: "British male voice",
        gender: "Male",
        language: "English",
        accent: "British",
        category: "Narration",
        age: "Middle Aged",
        color: "#2E7D32",
      },
      {
        id: "ap-5",
        name: "Aditi",
        description: "Hindi-English bilingual",
        gender: "Female",
        language: "Hindi",
        accent: "Indian",
        category: "Conversational",
        age: "Young Adult",
        color: "#7B1FA2",
      },
      {
        id: "ap-6",
        name: "Raveena",
        description: "Indian English accent",
        gender: "Female",
        language: "English",
        accent: "Indian",
        category: "Conversational",
        age: "Middle Aged",
        color: "#C2185B",
      },
    ],
  },
  {
    id: "google-tts",
    name: "Google Cloud TTS",
    description: "Powered by DeepMind's WaveNet technology for lifelike voices",
    Logo: GoogleTTSLogo,
    tagline: "WaveNet powered",
    voices: [
      {
        id: "gt-1",
        name: "Wavenet-A",
        description: "Smooth female voice",
        gender: "Female",
        language: "English",
        accent: "American",
        category: "Narration",
        age: "Young Adult",
        color: "#4285F4",
      },
      {
        id: "gt-2",
        name: "Wavenet-B",
        description: "Deep male voice",
        gender: "Male",
        language: "English",
        accent: "American",
        category: "Narration",
        age: "Middle Aged",
        color: "#EA4335",
      },
      {
        id: "gt-3",
        name: "Wavenet-C",
        description: "Young female voice",
        gender: "Female",
        language: "English",
        accent: "British",
        category: "Conversational",
        age: "Young Adult",
        color: "#FBBC05",
      },
      {
        id: "gt-4",
        name: "Wavenet-D",
        description: "Versatile male voice",
        gender: "Male",
        language: "English",
        accent: "British",
        category: "Characters",
        age: "Middle Aged",
        color: "#34A853",
      },
      {
        id: "gt-5",
        name: "Neural2-A",
        description: "Next-gen female",
        gender: "Female",
        language: "English",
        accent: "American",
        category: "News",
        age: "Young Adult",
        color: "#4285F4",
      },
    ],
  },
];

export const VOICE_COLORS: string[] = [
  "#7C3AED",
  "#2563EB",
  "#DB2777",
  "#059669",
  "#D97706",
  "#4F46E5",
  "#EC4899",
  "#0891B2",
  "#FF9900",
  "#146EB4",
  "#E8365D",
  "#2E7D32",
  "#7B1FA2",
  "#C2185B",
  "#4285F4",
  "#EA4335",
  "#FBBC05",
  "#34A853",
];
